import React, { forwardRef } from "react";

import classNames from "classnames";

import { StyledSkeletonLoader } from "./Styles";

export const SkeletonLoader = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ className, ...rest }, ref) => {
  return (
    <StyledSkeletonLoader
      ref={ref}
      className={classNames("c-loader c-loader--linear", className)}
      {...rest}
    />
  );
});

SkeletonLoader.displayName = "SkeletonLoader";
